import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { ErrorMessage } from '../../spotlight/models/purchase/error-message.model';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-cart-functionality',
  templateUrl: './cart-functionality.component.html',
  styleUrls: ['./cart-functionality.component.css']
})
export class CartFunctionalityComponent implements OnInit {
  @Output() checkOut = new EventEmitter();
  cartInfo: any;
  cartItem: any;
  errorMessage = new ErrorMessage();
  isLoading: boolean;
  timezone:any;

  constructor(private agileIntegrationService: AgileIntegrationService,
              private activeModal: NgbActiveModal) {
                this.fetchCartInfo();
               }

  ngOnInit(): void {
    var zone = moment.tz.guess();       
    this.timezone = moment.tz(zone).format("z");
  }

  closeModal(): void {
    this.activeModal.close();
  }

  fetchCartInfo(): void {
    this.isLoading = true;
    this.agileIntegrationService.fetchCartInfo().subscribe(response => {
      this.cartInfo = response;
      this.cartInfo.TransferURL = this.cartInfo.TransferURL + 'bypasscart=true&';
      this.isLoading = false;
    },
    error => {
      this.errorMessage.isError = true;
      this.errorMessage.errorMessage = '';
      this.isLoading = false;
    });
  }

  checkOutMethod(): void {
    this.checkOut.emit(this.cartInfo.TransferURL);
  }

  deleteTicket(index): void {
    const tickets = {
      items: [{
        Type: this.cartInfo.ItemSummary[index].Type,
        ID: this.cartInfo.ItemSummary[index].ID,
        Quantity: this.cartInfo.ItemSummary[index].Quantity,
        TierID: this.cartInfo.ItemSummary[index].TierID,
        PriceType: this.cartInfo.ItemSummary[index].PriceType
        }]
      };

    this.agileIntegrationService.deleteTicket(tickets).subscribe(response => {
      console.log(response);
      this.fetchCartInfo();
    },
    error => {
      console.log(error);
      this.fetchCartInfo();
    });
  }

}
